<template>
  <el-dialog
    :visible="visible"
    :width="isMobile ? '300px' : '675px'"
    append-to-body
    :close-on-click-modal="false"
    class="status-modal"
    @open="beforeOpen"
    @close="beforeClose"
  >
    <loader-wrapper
      v-if="drivers && showDriverList"
      :loading="loading || isLoading"
    >
      <p style="color: #409eff">
        <b>Выберите водителя :</b>
      </p>
      <el-table height="350" :data="drivers" style="width: 100%">
        <el-table-column label="ИНН" prop="carrier_name">
          <template slot-scope="{ row }">
            <span v-if="row.carrier_name">{{ row.carrier_name }}</span>
            <span v-else style="font-size: 12px">Не указано</span>
          </template>
        </el-table-column>

        <el-table-column label="Водитель" prop="fio">
          <template slot-scope="{ row }">
            <span v-if="row.fio">{{ row.fio }}</span>
            <span v-else style="font-size: 12px">Не указано</span>
          </template>
        </el-table-column>
        <el-table-column align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search_driver"
              size="mini"
              placeholder="Введите для поиска"
              :disabled="loading"
              @blur="filteredDriverList"
              @keyup.enter.native="filteredDriverList"
            />
          </template>
          <template slot-scope="scope">
            <span
              v-if="chosenDriver(scope.row)"
              style="display: flex; justify-content: flex-end"
            >
              <i class="el-icon-success date success" />
              <p class="date success">выбран</p>
            </span>
            <span v-else>
              <el-button
                v-if="isOwner(scope.row)"
                class="action-btn"
                size="mini"
                @click="handleSelect(scope.row)"
              >
                Выбрать
              </el-button>
              <el-button
                v-else
                class="action-btn"
                plain
                type="warning"
                size="mini"
                @click="handChangeOwner(scope.row)"
              >
                Привязать
              </el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-button
        style="margin-top: 24px; width: 100% !important"
        @click="showDriverList = false"
      >
        Создать водителя
      </el-button>
    </loader-wrapper>
    <div v-else>
      <DriverAddInProgress
        :carrier-inn="innOrganization"
        :carrier-name="nameOrganization"
        @close="showDriverList = true"
      />
    </div>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapActions, mapGetters } from 'vuex'
import DriverAddInProgress from '@/views/LoadDay/Modals/components/DriverAddInProgress'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

export default {
  name: 'DriverModalInProgress',
  components: { LoaderWrapper, DriverAddInProgress },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    response: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      showDriverList: true,
      selected_driver: null,
      driver_id: null,
      search_driver: '',
      errorOrg: 'Организация не найдена',
      driver: {
        fio: '',
        driver_licence: '',
        passport: '',
        phone: '',
        carrier_inn: '',
        carrier_name: '',
        user_org_inn: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      drivers: 'responseRequest/getDrivers',
      getLoading: 'responseRequest/getLoading',
    }),
    innOrganization() {
      return this.response ? this.response.organization_inn : this.errorOrg
    },
    nameOrganization() {
      return this.response ? this.response?.organiztion_name : this.errorOrg
    },

    isLoading() {
      return this.loading || this.getLoading('Driver')
    },
  },
  watch: {},
  methods: {
    ...mapActions({
      getDrivers: 'responseRequest/fetchDrivers',
      changeOwner: 'responseRequest/changeDriverOwner',
      addDriver: 'responseRequest/addDriverToResponse',
    }),
    chosenDriver(driver) {
      return driver && driver?.id === this.response?.driver_id
    },
    handChangeOwner(driver) {
      this.changeOwner({
        response_request_id: this.response.id,
        driver_id: driver.id,
      })
    },

    filteredDriverList() {
      this.getDrivers({
        search: this.search_driver,
        response_request_id: this.response.id,
      })
    },
    handleSelect(data) {
      const { id } = data

      this.addDriver({
        response_request_id: this.response.id,
        driver_id: id,
      })
      this.$emit('update')
      this.beforeClose()
    },
    isOwner(row) {
      return Boolean(row?.user_id_match)
    },
    beforeOpen() {
      this.getDrivers({ response_request_id: this.response.id })
    },
    beforeClose() {
      this.loading = false
      this.selected_driver = null
      this.driver_id = null
      this.search_driver = ''
      this.$emit('close')
      this.showDriverList = true
    },
  },
}
</script>

<style lang="sass">
.status-modal
  .row-wrap
    margin-bottom: 16px
  .action-btn
    min-width: 130px
  .set-date-wrap
    display: flex
    justify-content: flex-start
    align-items: center
    margin-top: 8px
    .el-date-editor
      min-width: 270px
  .el-dialog__body
    color: #000
    *
      font-family: 'Rubik', sans-serif
    .date-at
      color: #67C23A
      font-size: 16px
      font-weight: bold
      margin-top: 8px
      margin-bottom: 4px
    .resp-time
      font-size: 14px
      font-weight: normal
      color: #98A9BC
      margin: 4px 0px
      text-transform: lowercase
    span
      font-size: 16px
      text-transform: uppercase
    p
      font-size: 16px
      text-transform: uppercase
      margin-bottom: 0px
      margin-top: 0px
      &.first
        text-transform: uppercase
        margin: 0px 0px 0px 40px
    .el-timeline-item
    .el-timeline-item__content
      font-size: 14px
      font-weight: bold
      margin-top: 8px
      color: #000
      button
        margin-left: 10px
    .el-timeline-item__node
      border: 1px solid
    .el-timeline-item__timestamp
      margin-left: -30px
      margin-top: 8px!important
      font-size: 14px
      font-weight: normal
      color: #98A9BC
      margin: 0px
    .set-btn
      display: flex
      margin-left: 10px
    .date
      font-size: 15px
      line-height: 14px
      color: #8694A4
      margin: 10px 0
      &.status
        text-decoration: underline
      &.info
        color: #909399
      &.success
        font-size: 16px
        font-weight: bold
        margin-left: 12px
        color: #67C23A
      &.warning
        color: #E6A23C
      &.danger
        color: #F56C6C
</style>
